/**
 * Copyright (c) Investec
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 */

export function lowerFirst(text: string) {
  return text[0].toLowerCase() + text.slice(1);
}
